/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as p from "react";
import { validateChildren as a } from "../utils/index.mjs";
import i from "./base/ConfigurationComponent.mjs";
import { MapBubbleLayerTooltip as m } from "./BubbleLayerTooltip.mjs";
const r = (e) => /* @__PURE__ */ p.createElement(i, { type: "bubble", ...e });
r.displayName = "MapBubbleLayer";
r.propTypes = {
  children: function(e, o, t) {
    return a(e, o, t, m);
  }
};
export {
  r as MapBubbleLayer
};
